import { render, staticRenderFns } from "./ExamAanmeldingen.vue?vue&type=template&id=2e0ff643&scoped=true"
import script from "./ExamAanmeldingen.vue?vue&type=script&lang=js"
export * from "./ExamAanmeldingen.vue?vue&type=script&lang=js"
import style0 from "./ExamAanmeldingen.vue?vue&type=style&index=0&id=2e0ff643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0ff643",
  null
  
)

export default component.exports